<template>
	<div class="filter search-bar" v-bind="config.attrs">
		<config-style-injector :config="config" :root-selector="`.search-bar`" />
		<input ref="search-input" v-model="value" :aria-label="content.aiSearchFlyer" :placeholder="content.aiSearchFlyer"
			class="search-input" tabindex="0" type="text" @blur="handleBlur" @focus="setSearchFocusState(true)"
			@keyup.enter="handleSubmit(value)" />
		<svg class="ai-icon" width="32" height="28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 4.8A4.8 4.8 0 0 1 4.8 0h22.4A4.8 4.8 0 0 1 32 4.8v18.4a4.8 4.8 0 0 1-4.8 4.8H4.8A4.8 4.8 0 0 1 0 23.2V4.8Z"
				fill="url(#a)" />
			<path fill-rule="evenodd" clip-rule="evenodd"
				d="m12.446 13.572 1.216-3.75h.745l1.216 3.75 3.646 1.25v.767l-3.646 1.25-1.215 3.75h-.746l-1.216-3.75-3.646-1.25v-.767l3.646-1.25ZM19.325 8.519l.626-1.93h.746l.626 1.93 1.877.643v.767l-1.877.644-.626 1.93h-.746l-.626-1.93-1.877-.644v-.767l1.877-.643Z"
				fill="#fff" />
			<defs>
				<linearGradient id="a" x1="2" y1="0" x2="27.227" y2="28.926" gradientUnits="userSpaceOnUse">
					<stop stop-color="#00B2FF">
						<animate attributeName="stop-color" values="#00B2FF; #EB00FF; #00B2FF" dur="4s" repeatCount="indefinite" />
					</stop>
					<stop offset="1" stop-color="#EB00FF">
						<animate attributeName="stop-color" values="#EB00FF; #00B2FF; #EB00FF" dur="4s" repeatCount="indefinite" />
					</stop>
				</linearGradient>
			</defs>
		</svg>
		<span v-if="value" class="clear" @click="clearSearch">
			<img alt="clear" src="/images/icon-close.svg">
		</span>
		<button aria-label="search" class="search-icon" @click="handleSubmit(value)">
			<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
				<g>
					<path
						d="M495,466.2L377.2,348.4c29.2-35.6,46.8-81.2,46.8-130.9C424,103.5,331.5,11,217.5,11C103.4,11,11,103.5,11,217.5   S103.4,424,217.5,424c49.7,0,95.2-17.5,130.8-46.7L466.1,495c8,8,20.9,8,28.9,0C503,487.1,503,474.1,495,466.2z M217.5,382.9   C126.2,382.9,52,308.7,52,217.5S126.2,52,217.5,52C308.7,52,383,126.3,383,217.5S308.7,382.9,217.5,382.9z"
						fill="currentColor" />
				</g>
			</svg>
		</button>
		<div class="dropdown" v-show="searchInputFocused || resultsLoading">
			<ul v-if="resultsLoading">
				<li class="instructions">Loading…</li>
			</ul>
			<ul v-else>
				<li class="instructions">Select from these recent queries… or enter your own.</li>
				<li v-for="prompt in prompts" :key="prompt" @click="selectPrompt(prompt)">
					<button>{{ prompt }}</button>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import featureMixin from "@/mixins/featureMixin";
import ConfigStyleInjector from "@/components/style-injector/ConfigStyleInjector.vue";

export default {
	name: "SearchBarFilter",
	components: { 
		ConfigStyleInjector,
	},

	mixins: [featureMixin],

	data() {
		return {
			value: '',
			prompts: [
				'Alert me when Raspberries are on sale',
				'Show me the best deals in Health Foods',
				'What meals can I make with today’s flyer?'
			]
		}
	},

	props: {
		hidden: {
			type: Boolean,
			default: false
		}
	},

	mounted() {
		this.value = this._config.value;
	},

	computed: {
		...mapGetters(['content', 'highlightResults']),
		...mapGetters('filters', ["searchQuery"]),
		...mapState(['searchInputFocused']),
		...mapState('search', ['resultsLoading'])
	},

	methods: {
		...mapActions(['setSearchInputFocusState', 'toggleSideBarState']),
		...mapActions('events', ['triggerEvent']),
		...mapActions('search', ['queryAISearch']),

		clearSearch() {
			this.value = '';
			this._config.value = '';
		},

		selectPrompt(prompt) {
			this.value = prompt;
			this.handleSubmit(prompt);
		},

		handleSubmit(query) {
			this.queryAISearch(query);
		},
		setSearchFocusState(val) {
			this.setSearchInputFocusState(val)
			this.toggleSideBarState(false);
		},

		handleBlur() {
			setTimeout(() => {
				this.setSearchInputFocusState(false)
			}, 100)
		}
	},
	watch: {
		searchQuery(val) {
			console.log('search query update:', val)
			this.value = this.config.value;
		}
	}
}
</script>

<style lang="scss" scoped>

.clear {
  position: absolute;
  right: 40px;
  top: 51%;
  transform: translateY(-50%);
  line-height: 1em;
  font-family: monospace;
  cursor: pointer;
}

.search-bar {
  display: flex;
  position: relative;
  min-width: 30em;
  min-height: 34px;
}

.search-bar input {
  flex-basis: 100%;
  border: 1px solid #AFAFAF;
  border-radius: 4px;;
  /* border-color: var(--tertiary-color); */
  font-size: 16px;
  /*height: 35px;*/
  text-overflow: ellipsis;
  padding-left: 2.6em;
  padding-right: 4em;
  width: 100%;
}

.search-bar .search-icon {
    width: 30px;
    color: #fff;
    background-color: var(--secondary-color);
    border: none;
    border-radius: 4px;
    position: absolute;
    right: 0px;
    height: 100%;
    min-height: auto;

  svg {
	width: 80%
  }

}

.search-bar .search-icon:hover {
  background-color: #A90000 !important;
}

.ai-icon {
	position: absolute;
	left: 4px;
	top: 3px;
	/* top: 50%; */
	/* transform: translateY(-50%); */
}

.dropdown {
	position: absolute;
	top: 105%;
	left: 0;
	width: 100%;
	background-color: #fff;
	border: 1px solid #AFAFAF;
	border-radius: 0 0 4px 4px;
	z-index: 100;

	ul {
		list-style: none;
		padding: 0;
		margin: 0;

		li {
			&.instructions {
				padding: 12px 20px;
				font-size: 16px;
				color: #fff;
				background: linear-gradient(-45deg, #00B2FF, #EB00FF, #00B2FF, #EB00FF);
				background-size: 400% 400%;
				animation: Gradient 16s infinite;
			}

			@keyframes Gradient {
				0% {background-position: 0% 50%;}
				100% {background-position: 100% 50%;}				
			}
			
			button {
				width: 100%;
				text-align: left;
				justify-content: start;
				padding: 12px 20px;
				border: none;
				background-color: #fff;
				color: #414141;
				font-size: 14px;
			}
		}
	}
}

</style>
